import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { getCompanyDrawerData } from 'services/app';

export default function useCompanyDrawerData(
  slug: string,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    `company-${slug}-drawer-data`,
    () =>
      getCompanyDrawerData(slug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
